<template>
  <ModalFormWrapper
    title="Rezervačný formulár"
    swipe-to-close
    :step="step"
    @popup-opened="initData"
    @popup-closed="resetComponentData"
    @step-changed="(e) => (step = e)"
  >
    <FirstStep v-if="step === 1" @continue="step++" :remove-inner-data="removeInnerData" />
    <SecondStep
      v-if="step === 2"
      @submit="Reservations.makeReservation(selectedReservationDateIso, selectedTime)"
    />
  </ModalFormWrapper>
</template>

<script setup lang="ts">
import { DateTime } from 'luxon'
import { computed, provide, ref } from 'vue'

import Reservations from '@/assets/classes/parking/Reservations'
import { ToReadableTime } from '@/assets/composables/mappers'
import { useParkingReservationData } from '@/assets/composables/parking/useParkingReservationData'
import type { SelectedSlotData } from '@/assets/composables/types'
import FirstStep from '@/components/parking/reservationForm/firstStep.vue'
import SecondStep from '@/components/parking/reservationForm/secondStep.vue'
import ModalFormWrapper from '@/components/wrappers/ModalFormWrapper.vue'

const {
  currentDate,
  step,
  selectedDate,
  selectedReservationDateIso,
  selectedTime,
  formattedTime,
  validation,
  validateForm,
  resetData,
} = useParkingReservationData()

const removeInnerData = ref<boolean>(false)
const formattedValues = computed<SelectedSlotData>(() => ({
  date: selectedReservationDateIso.value
    ? DateTime.fromISO(selectedReservationDateIso.value, { zone: 'Europe/Bratislava' }).toFormat(
        'dd. MM. yyyy (cccc)',
      )
    : '',
  time: ToReadableTime(selectedTime.value),
}))

const initData = () => {
  removeInnerData.value = false
  currentDate.value = DateTime.now()
}

const resetComponentData = () => {
  removeInnerData.value = true
  resetData()
}

provide('formData', {
  currentDate,
  selectedDate,
  selectedReservationDateIso,
  selectedTime,
  formattedTime,
  validation,
  validateForm,
  formattedValues,
})
</script>
